import { render, staticRenderFns } from "./OrderPackageWikiModal.vue?vue&type=template&id=58dff05e&"
import script from "./OrderPackageWikiModal.vue?vue&type=script&lang=js&"
export * from "./OrderPackageWikiModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderPackageWikiModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports